import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Button, Alert } from '../shim/reactstrap';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../api/ApiClient';

export const ChangePassword = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [passwordCurrent, setPasswordCurrent] = useState('');
  const [passwordNew, setPasswordNew] = useState('');
  const [passwordNewConfirm, setPasswordNewConfirm] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Client-side validation
    if (!passwordCurrent) {
      setError('Current password is required');
      return;
    }
    if (!passwordNew) {
      setError('New password is required');
      return;
    }

    setIsSubmitting(true);

    try {
      await apiClient.changePassword(passwordCurrent, passwordNew, passwordNewConfirm);
      setSuccess('Password changed successfully! Redirecting to profile...');
      // Clear the form
      setPasswordCurrent('');
      setPasswordNew('');
      setPasswordNewConfirm('');
      // Redirect to profile after 2 seconds
      setTimeout(() => {
        navigate('/profile');
      }, 2000);
    } catch (err) {
      setError(err.message || 'Failed to change password. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <Card>
            <CardHeader>
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Change Password</h4>
                <Button color="link" size="sm" tag={Link} to="/profile">
                  Back to Profile
                </Button>
              </div>
            </CardHeader>
            <CardBody>
              <div className="mb-3">
                <strong>User:</strong> {user?.Name || user?.Email || 'N/A'}
              </div>

              {error && <Alert color="danger" fade={false}>{error}</Alert>}
              {success && <Alert color="success" fade={false}>{success}</Alert>}

              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label for="passwordCurrent">Current Password</Label>
                  <Input
                    type="password"
                    id="passwordCurrent"
                    name="passwordCurrent"
                    placeholder="Enter your current password"
                    value={passwordCurrent}
                    onChange={(e) => setPasswordCurrent(e.target.value)}
                    required
                    autoComplete="current-password"
                    disabled={isSubmitting}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="passwordNew">New Password</Label>
                  <Input
                    type="password"
                    id="passwordNew"
                    name="passwordNew"
                    placeholder="Enter your new password"
                    value={passwordNew}
                    onChange={(e) => setPasswordNew(e.target.value)}
                    required
                    autoComplete="new-password"
                    disabled={isSubmitting}
                  />
                  <small className="form-text text-muted">
                    Password must be at least 6 characters long
                  </small>
                </FormGroup>
                <FormGroup>
                  <Label for="passwordNewConfirm">Confirm New Password</Label>
                  <Input
                    type="password"
                    id="passwordNewConfirm"
                    name="passwordNewConfirm"
                    placeholder="Re-enter your new password"
                    value={passwordNewConfirm}
                    onChange={(e) => setPasswordNewConfirm(e.target.value)}
                    required
                    autoComplete="new-password"
                    disabled={isSubmitting}
                  />
                </FormGroup>
                <div className="d-flex justify-content-between">
                  <Button color="secondary" tag={Link} to="/profile" disabled={isSubmitting}>
                    Cancel
                  </Button>
                  <Button color="primary" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Changing Password...' : 'Change Password'}
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </div>
      </div>
    </Container>
  );
};
